/**
 * Creates a sequential queue that processes items one at a time,
 * in the order they were enqueued. Calling `drain()` while already
 * running is a no-op — the running loop picks up any newly-pushed items.
 */
export function createSequentialQueue<T>(
  processor: (item: T) => Promise<void>,
): {
  push: (item: T) => void;
  drain: () => Promise<void>;
} {
  const queue: T[] = [];
  let running = false;

  async function drain() {
    if (running) return;
    running = true;
    while (queue.length > 0) {
      const item = queue.shift()!;
      try {
        await processor(item);
      } catch {
        // Errors in individual items do not stop subsequent items
      }
    }
    running = false;
  }

  return {
    push(item: T) {
      queue.push(item);
    },
    drain,
  };
}
